import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function PaletteFill(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 12c0 5.04 3.596 9 8.5 9 .597 0 1.034-.03 1.349-.078.1-.016.18-.032.247-.047a5.506 5.506 0 00-.13-.252l-.133-.239a24.801 24.801 0 01-.247-.445C12.33 19.456 12 18.766 12 18c0-.673.172-1.286.573-1.784.392-.487.922-.76 1.445-.922.959-.295 2.21-.294 3.37-.294h.112c1.88 0 3.5-1.481 3.5-4 0-4.836-3.885-8-9-8a9 9 0 00-9 9zm10.192 9.125v-.003.003zM17.5 16c2.5 0 4.5-2 4.5-5 0-5.523-4.477-9-10-9S2 6.477 2 12s3.977 10 9.5 10c3.39 0 2.873-.92 2.188-2.135C13.363 19.288 13 18.644 13 18c0-2 2-2 4.5-2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 8a1 1 0 100-2 1 1 0 000 2zm0 1a2 2 0 100-4 2 2 0 000 4zM7 11a1 1 0 100-2 1 1 0 000 2zm0 1a2 2 0 100-4 2 2 0 000 4zM17 11a1 1 0 100-2 1 1 0 000 2zm0 1a2 2 0 100-4 2 2 0 000 4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10a1 1 0 11-2 0 1 1 0 012 0zM13 7a1 1 0 11-2 0 1 1 0 012 0zM18 10a1 1 0 11-2 0 1 1 0 012 0z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(PaletteFill);
export default ForwardRef;